// extracted by mini-css-extract-plugin
module.exports = {"content":"_2apz0V","image":"ZqXf3p","logo":"_2zrbjp","title":"_28PdOS","subTitle":"_2Dq3Su"};